import { EntityFilter, EntityWithId } from '../baseEntities'

export enum UserDTOFields {
    FirstName = 'nombre',
    LastName = 'apellido',
    Email = 'mail',
    PhoneNumber = 'telefono',
    UserPositionCode = 'codUsuarioCargo'
}

export type UserDTO = {
    [UserDTOFields.FirstName]: string
    [UserDTOFields.LastName]: string
    [UserDTOFields.Email]: string
    [UserDTOFields.PhoneNumber]?: string | null
    [UserDTOFields.UserPositionCode]: number
}

export enum UserViewDTOFields {
    UserPositionDesc = 'descUsuarioCargo',
    LastLoginDate = 'fechaUltAcceso',
    Active = 'estaActivo',
    Blocked = 'estaBloqueado'
}

export type UserViewDTO = UserDTO &
    EntityWithId<number> & {
        [UserViewDTOFields.UserPositionDesc]: string
        [UserViewDTOFields.LastLoginDate]: Date
        [UserViewDTOFields.Active]: boolean
        [UserViewDTOFields.Blocked]: boolean
    }

export type UserInsertDTO = UserDTO

export enum UserFilterDTOFields {
    UserDescription = 'descUsuario',
    LastLoginDateStart = 'fechaUltAccesoDesde',
    LastLoginDateEnd = 'fechaUltAccesoHasta'
}

export type UserFilterDTO = EntityFilter & {
    [UserDTOFields.FirstName]?: string
    [UserDTOFields.LastName]?: string
    [UserFilterDTOFields.UserDescription]?: string
    [UserDTOFields.Email]?: string
    [UserDTOFields.UserPositionCode]?: number
    [UserFilterDTOFields.LastLoginDateStart]?: Date
    [UserFilterDTOFields.LastLoginDateEnd]?: Date
    [UserViewDTOFields.Active]?: boolean
    [UserViewDTOFields.Blocked]?: boolean
}

export enum UserGroupViewDTOFields {
    GroupId = 'idGrupo',
    GroupName = 'nombreGrupo',
    GroupAssigned = 'perteneceAGrupo',
    CountryCode = 'codPais',
    CountryName = 'nombrePais',
    Observations = 'observaciones',
    CodSistema = 'codSistema',
    NombreSistema = 'nombreSistema'
}

export type UserGroupViewDTO = {
    [UserGroupViewDTOFields.GroupId]: number
    [UserGroupViewDTOFields.GroupName]: string
    [UserGroupViewDTOFields.GroupAssigned]: boolean
    [UserGroupViewDTOFields.CountryCode]: number
    [UserGroupViewDTOFields.CountryName]: string
    [UserGroupViewDTOFields.Observations]: string
    [UserGroupViewDTOFields.CodSistema]: number | null
    [UserGroupViewDTOFields.NombreSistema]: string | null
}

export enum UserGroupFilterDTOFields {
    CodsPais = 'codsPais',
    CodSistema = 'codSistema',
}

export type UserGroupFilterDTO = {
    [UserGroupFilterDTOFields.CodsPais]?: string
    [UserGroupFilterDTOFields.CodSistema]?: number
}

export type UserGroupUpdateDTO = {
    codSistema: number
    idsGrupo: number[]
}

export type UserGroupListResponseDTO = {
    disponibles: UserGroupViewDTO[]
    asociados: UserGroupViewDTO[]
}

export enum GroupUserFilterDTOFields {
    CodsCargo = 'codsCargo',
    Nombre = 'nombre',
    Mail = 'mail',
    SoloActivos = 'soloActivos'
}
